export default function canDo<T extends Function>(callback: T) {
  return (doIt: boolean): T | undefined => {
    if (doIt) {
      return callback()
    }

    return undefined
  }
}
